import React from 'react';
type Props = {
  id?: string;
  children: React.ReactNode;
  tone?: 'cream' | 'white' | 'navy' | 'renal';
  className?: string;
};
const tones: Record<string, string> = {
  cream: 'bg-cream-50 text-navy-800',
  white: 'bg-white text-navy-800',
  navy: 'bg-navy-800 text-white',
  renal: 'bg-renal-50 text-navy-800'
};
export function SectionShell({
  id,
  children,
  tone = 'cream',
  className = ''
}: Props) {
  return <section id={id} className={`w-full ${tones[tone]} ${className}`} data-id="element-278" data-mp="2i5qlz7c7phjd">
      <div className="mx-auto w-full max-w-3xl px-5 py-14 sm:px-8 sm:py-20" data-id="element-279" data-mp="2n5mot396b2xc">{children}</div>
    </section>;
}
export function Eyebrow({
  children
}: {
  children: React.ReactNode;
}) {
  return <p className="text-[11px] sm:text-xs font-bold uppercase tracking-[0.18em] text-renal-600 text-center" data-id="element-280" data-mp="2e4wyug6lg6rj">
      {children}
    </p>;
}
export function SectionTitle({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <h2 className={`mt-3 font-display font-extrabold text-[27px] leading-[1.15] sm:text-4xl sm:leading-tight text-center tracking-tight ${className}`} data-id="element-281" data-mp="cbqxt5rn2x1q">
      {children}
    </h2>;
}
export function SectionLead({
  children
}: {
  children: React.ReactNode;
}) {
  return <p className="mt-4 text-center text-[15px] sm:text-lg leading-relaxed text-navy-700/80" data-id="element-282" data-mp="2bsvt71mrx003">
      {children}
    </p>;
}